module.exports = {"Nikon":{"regex":"Coolpix S800c","device":"camera","model":"Coolpix S800c"},"Samsung":{"regex":"EK-G[CN][0-9]{3}","device":"camera","models":[{"regex":"EK-GN120","model":"GALAXY NX"},{"regex":"EK-GC100","model":"GALAXY Camera"},{"regex":"EK-GC110","model":"GALAXY Camera WiFi only"},{"regex":"EK-GC200","model":"GALAXY Camera 2"},{"regex":"EK-GC([0-9]{3})","model":"GALAXY Camera $1"}]}}


//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/fixtures/regexes/device/cameras.json
// module id = 862
// module chunks = 113